<template>
  <div class="line-progress-wrapper">
    <div :style="{ background: color }" class="line-progress-bar">
      <span :style="{ width: `${width}%`, background: color }" />
    </div>
    <div class="slot">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: Number, required: true },
    color: { type: String, default: 'brand' },
  },
};
</script>

<style lang="scss">
.line-progress-wrapper {
  display: flex;
  align-items: center;
  padding-left: 28px;
  position: relative;

  .line-progress-bar {
    height: 4px;
    position: relative;
    background: var(--main-light-shade-2);
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    overflow: hidden;
    width: 90%;

    span {
      background: var(--accent);
      display: block;
      height: 100%;
      position: relative;
      overflow: hidden;
    }
  }

  .slot {
    margin-left: var(--spacing-8);
    color: var(--main-dark-shade-3);
    position: absolute;
    right: 0;
  }
}
</style>
